import $ from 'jquery';


$(function () {
   APP.roomBooking.init();
   APP.bookingMenuTabs.init();
   APP.availabilityChecker.init();
});